import { render, staticRenderFns } from "./WorkOrderInfo.vue?vue&type=template&id=2a31f5fa&scoped=true"
import script from "./WorkOrderInfo.vue?vue&type=script&lang=js"
export * from "./WorkOrderInfo.vue?vue&type=script&lang=js"
import style0 from "./WorkOrderInfo.vue?vue&type=style&index=0&id=2a31f5fa&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a31f5fa",
  null
  
)

export default component.exports